export default __webpack_public_path__ + "static/media/AW4.625a2858.jpg";